import axios from "axios";
import moment from "moment"
import {LOCAL_STORAGE, DATE_FORMATS} from '../../utils/constant'

const ReadAxios = async function (props = {}) {
  var gett = LOCAL_STORAGE.userToken
  var customerNo = LOCAL_STORAGE.customerNo
  var userId = LOCAL_STORAGE.userId
  var locales = LOCAL_STORAGE.locales === "en" ? "en-IN" : `pt-BR`

  let congData = JSON.stringify({
    customerNumber: +customerNo,
    userId: userId,
    customer_no: +customerNo,
    user_id: +userId,
    customerNo: +customerNo,
    searchTerm: props.searchTerm,
    ...props.readItems
  });

  console.log("TP :", props);

  const apiURL = props.completeURL
    ? `${props.completeURL}`
    :
    props.FileURL ?
    `${props.FileURL}`
    : props.baseURL ? `${props.baseURL}/${props.url}` : `${process.env.REACT_APP_MASTER_API}/${props.url}`;
  // : `https://dev-commongateway.elixia.tech/${props.url}`;

  if (props.FileURL) {
    // try {
    return new Promise((resolve, reject) => {
      var config = {
        method: "get",
        url: apiURL,
        headers: {
          Authorization: `${gett}`,
          "Content-Type": "application/json",
          "Accept-Language": locales,
          "Access-Control-Allow-Origin": "*"
        },
      };

      axios(config)
        .then(function (response) {
          // console.log(JSON.stringify(response.data));
          resolve(response);
        })
        .catch(function (error) {
          // console.log(error);
          reject(error);
        });
    });
    // } catch (e) {
    //   return console.log("ErrorRead", e);
    // }
  }
  else if (props.completeURL) {
    // try {
    return new Promise((resolve, reject) => {
      var config = {
        method: "get",
        url: apiURL,
        headers: {
          Authorization: `${gett}`,
          "Content-Type": "application/json",
          "Accept-Language": locales,
          "Access-Control-Allow-Origin": "*"
        },
        data: congData,
        params: {
          customer_no: +customerNo,
          user_id: +userId,
          userId: +userId,
          customerNo: +customerNo,
          customerNumber: +customerNo,
          ...props.readItems
        },
      };

      axios(config)
        .then(function (res) {
          // console.log(JSON.stringify(response.data));
          if (res.data.status === 200 && res.data.resultSet !== "" && res.data.resultSet) {
            const resultSet = res.data.resultSet.map(rs => {
              try {
                if (rs.hasOwnProperty('createdOn')) {
                  const createdOn = moment(rs.createdOn).isValid() ? moment.utc(rs.createdOn).local().format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                  rs.createdOn = createdOn
                }
                if (rs.hasOwnProperty('updatedOn')) {
                  const updatedOn = moment(rs.updatedOn).isValid() ? moment.utc(rs.updatedOn).local().format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                  rs.updatedOn = updatedOn
                }
                rs.updatedBy = rs.updatedBy || "N/A"
              } catch (error) {
                console.log("Date Format Error")
              }
              return rs;
            })
            res.data.resultSet = resultSet
          resolve(res);
        }else{
          resolve(res);
        }
      })
        .catch(function (error) {
          // console.log(error);
          reject(error);
        });
    });
    // } catch (e) {
    //   return console.log("ErrorRead", e);
    // }
  } else {
    try {
      return new Promise((reslove, reject) => {
        axios
          .post(apiURL, congData, {
            headers: {
              "content-type": "application/json",
              Authorization: `${gett}`,
              "Accept-Language": locales,
              "Access-Control-Allow-Origin": "*"
            },
          })
          .then((res) => {
            if (res.data.status === 200 && res.data.resultSet !== "" && res.data.resultSet) {
              const resultSet = res.data.resultSet.map(rs => {
                try {
                  if (rs.hasOwnProperty('createdOn')) {
                    const createdOn = moment(rs.createdOn).isValid() ? moment.utc(rs.createdOn).local().format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                    rs.createdOn = createdOn
                  }
                  if (rs.hasOwnProperty('updatedOn')) {
                    const updatedOn = moment(rs.updatedOn).isValid() ? moment.utc(rs.updatedOn).local().format(DATE_FORMATS.DDMMYYYHHmm) : "N/A"
                    rs.updatedOn = updatedOn
                  }
                  rs.updatedBy = rs.updatedBy || "N/A"
                } catch (error) {
                  console.log("Date Format Error")
                }
                return rs;
              })
              res.data.resultSet = resultSet
              reslove(res);
            } else {
              if (res.data.permissions) {
                reslove(res);
              } else {
                reslove(res);
              }
            }
          })
          .catch((err) => {
            console.log('err in read', err);
            reject(err);
          });
      });
    } catch (e) {
      return console.log("ErrorRead", e);
    }
  }
};

export default ReadAxios;
